import { render, staticRenderFns } from "./LessonResourceItem.vue?vue&type=template&id=66a6b355&scoped=true&"
import script from "./LessonResourceItem.vue?vue&type=script&lang=js&"
export * from "./LessonResourceItem.vue?vue&type=script&lang=js&"
import style0 from "./LessonResourceItem.vue?vue&type=style&index=0&id=66a6b355&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a6b355",
  null
  
)

export default component.exports